import { useSelector } from "react-redux";

import { parse } from "@sportal/cdk/timePicker";
import { useIntlTranslate } from "../../../../../hooks";
import { is24HourFormat } from "../../../../../store/account";
import { getFirstDayOfWeek } from "../../../../../store/config.selectors";
import { getDaysShifted } from "../schedules.selectors";
import { translateDays } from "./translateDays";
import { renderDuration } from "./renderDuration";

export const useScheduleRuleData = (
  timeStart,
  timeEnd,
  selectedDays,
  useShortNotations
) => {
  const timeFormat24h = useSelector(is24HourFormat);
  const firstDayOfWeek = useSelector(getFirstDayOfWeek);
  const translate = useIntlTranslate();

  const start = parse(timeStart, timeFormat24h);
  const end = parse(timeEnd, timeFormat24h);

  const selectedSortedDays = getDaysShifted(firstDayOfWeek).filter((day) =>
    selectedDays.includes(day)
  );
  const days = translateDays(translate, selectedSortedDays, useShortNotations);
  const duration = renderDuration(
    translate,
    timeStart,
    timeEnd,
    useShortNotations
  );

  return {
    start,
    end,
    days,
    duration,
  };
};
